export const TRANSIENT_INPUT_HEIGHT = "4rem";

export const SCENARIO_COLUMN_CLASS_NAME = "flex flex-col gap-4";

export const FLUSHING_SETTINGS_VALUES_CLASS_NAME = "flex w-[50rem] shrink-0 items-center gap-4";

export const FLUSHING_SETTINGS_CELL_CLASS_NAME = "w-[24rem] shrink-0";

export const FLUSHING_SETTINGS_INPUT_WIDTH = "20rem max-w-[20rem]";
